/**
 * Created by yunanw on 17/12/20.
 */
const UserType = Object.freeze({
  Type1: 'type1',
  Type2: 'type2',
  Type3: 'type3',
  Type4: 'type4',
  Type5: 'type5',
  Type6: 'type6',
  Type7: 'type7',
  Type8: 'type8',
  Type9: 'type9',
  Type10: 'type10',
  Type11: 'type11'
})

export default {
  UserType: UserType,
  getCurrentUserType: function (component) {
    if (component.$route.query.UserType) {
      window.localStorage.setItem('UserType', component.$route.query.UserType)
    }
    return window.localStorage.getItem('UserType')
  },
  getMyId: function () {
    return window.localStorage.getItem('MyId')
  },
  alertOnce: function (component, msg) {
    let usertype = this.getCurrentUserType(component)
    if (!usertype) {
      return
    }
    if (!window.localStorage.getItem('alertOnce' + usertype)) {
      component.$vux.alert.show({title: '提示', content: msg})
      window.localStorage.setItem('alertOnce' + usertype, '1')
    }
  },
  alertOnceInnerTitle: function (component, msg, title, types) {
    let usertype = this.getCurrentUserType(component)
    console.log(usertype)
    if (!usertype) {
      return
    }
    if (!window.localStorage.getItem('alertOnce' + usertype + types)) {
      component.$vux.alert.show({title: title, content: msg})
      window.localStorage.setItem('alertOnce' + usertype + types, '1')
    }
  },
  validateGoodSearch (component, condition) {
    let vux = component.$vux
    if (condition === '') {
      vux.alert.show({title: '警告', content: '请输入查询条件,长度不能少于2位'})
      return false
    }

    let regex = new RegExp('^[0-9]*$')
    if (regex.test(condition) && condition.length < 2) {
      vux.alert.show({title: '警告', content: '商品编码长度不能少于2位'})
      return false
    }
    return true
  },
  validateRuleSearch (component, condition) {
    let vux = component.$vux
    if (condition === '') {
      vux.alert.show({title: '警告', content: '请输入查询内容'})
      return false
    }
    return true
  },
  getUrlParam: function (name) {
    var reg = new RegExp(name + '=([^&]*)(&|$)')
    var r = window.location.hash.substr(1).match(reg)
    if (r != null) return unescape(r[1])
    return null
  },
  getUrlParam_Title: function (name) {
    var reg = new RegExp(name + '=([^&]*)(&|$)')
    var r = window.location.hash.substr(1).match(reg)
    if (r != null) return decodeURI(r[1])
    return null
  },
  setPower: function (powerId) {
    if (powerId && powerId != null && powerId !== 'undefined' && powerId !== '') {
      return window.localStorage.setItem('localSession', powerId)
    } else if (powerId === '') {
      return window.localStorage.removeItem('localSession')
    }
  },
  getPower: function () {
    return window.localStorage.getItem('localSession')
  },
  setfoodSession: function (powerId) {
    if (powerId && powerId != null && powerId !== 'undefined' && powerId !== '') {
      return window.localStorage.setItem('foodusersessions', powerId)
    } else if (powerId === '') {
      return window.localStorage.removeItem('foodusersessions')
    }
  },
  getfoodSession: function () {
    return window.localStorage.getItem('foodusersessions')
  },
  removefoodSession: function () {
    return window.localStorage.removeItem('foodusersessions')
  },
  setNodeSession: function (powerId) {
    if (powerId && powerId != null && powerId !== 'undefined' && powerId !== '') {
      return window.localStorage.setItem('nodeusersessions', powerId)
    } else if (powerId === '') {
      return window.localStorage.removeItem('nodeusersessions')
    }
  },
  getNodeSession: function () {
    return window.localStorage.getItem('nodeusersessions')
  },
  removeNodeSession: function () {
    return window.localStorage.removeItem('nodeusersessions')
  },
  getcustomsSession: function (name) {
    return window.localStorage.getItem(name)
  },
  removecustomsSession: function (name) {
    return window.localStorage.removeItem(name)
  },
  setcustomsSession: function (name, value) {
    if (value && value != null && value !== 'undefined' && value !== '') {
      console.log(value)
      console.log(name)
      return window.localStorage.setItem(name, value)
    } else if (value === '') {
      return window.localStorage.removeItem(name)
    }
  }
}



// WEBPACK FOOTER //
// ./src/tools/common.js